export default __webpack_public_path__ + "static/media/AMS_B.f981e30f.svg";